<template lang="pug">
  div(class="documents-api-action-status")
    h2(class="title-32px fw-700 mb-8") {{ dialogTitle }}
    block-documents-api-action-results(
      v-if="showResult"
      :failed-documents="failedDocuments"
      :image="resultImage"
    )
    block-documents-api-action-list(
      v-else
      :documents="documents"
      :documents-states="documentsStates"
      :statuses="statuses"
    )
    div(class="d-flex align-center justify-end pt-8")
      div(
        v-if="!showResult && !showStop"
        class="two-buttons-wrapper"
      )
        v-btn(
          height="48"
          @click="closeModal(false)"
        ) {{ $t('Cancel') }}
        v-btn(
          class="secondary-button error-btn"
          @click="handleRequest"
        ) {{ approveButtonText }}
      v-btn(
        v-else-if="showResult"
        class="main-button w-100"
        @click="closeModal"
      ) {{ $t('Ok') }}
      v-btn(
        v-else-if="showStop"
        class="secondary-button error-btn w-100 documents-sign-status__action"
        @click="handleStop"
      ) {{ stopButtonText }}
</template>

<script>
import BlockDocumentsApiActionList from '~/modules/documents/components/blocks/block-documents-api-action-list'
import BlockDocumentsApiActionResults from '~/modules/documents/components/blocks/block-documents-api-action-results.vue'

export default {
  name: 'MDocumentsApiActionStatus',
  components: {
    BlockDocumentsApiActionResults,
    BlockDocumentsApiActionList
  },
  props: {
    changeDialogWidth: {
      type: Function,
      default: () => {}
    },
    closeModal: {
      type: Function,
      default: null
    },
    documents: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
    resultTitle: {
      type: String,
      default: null
    },
    request: {
      type: Function,
      required: true
    },
    stopButtonText: {
      type: String,
      default: null
    },
    approveButtonText: {
      type: String,
      default: null
    },
    genericErrorMessage: {
      type: String,
      default: null
    },
    additionalCheckValue: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isStopped: false,
      showStop: false,
      showResult: false,
      documentsStates: {}
    }
  },
  computed: {
    statuses() {
      return {
        created: 'created',
        success: 'success',
        error: 'error'
      }
    },
    failedDocuments() {
      const failedDocuments = []
      Object.entries(this.documentsStates).filter(([id, value]) => {
        if (this._.get(value, 'status') === this.statuses.error) {
          const document = this._.find(this.documents, document => document.id === id)
          failedDocuments.push({
            title: this._.get(document, 'title'),
            reason: this._.get(value, 'error')
          })
        }
      })
      return failedDocuments
    },
    isAllDocumentsFailed() {
      return Object.values(this.documentsStates).every(obj => {
        return obj.status === this.statuses.error
      })
    },
    dialogTitle() {
      if (this.showResult) {
        if (this.failedDocuments.length) return this.$t('Some errors occur while action')
        else if (this.isAllDocumentsFailed) return this.$t('All documents failed to proceed action')
        return this.resultTitle
      }
      return this.title
    },
    resultImage() {
      return this.isAllDocumentsFailed
        ? require('~/assets/images/warning.png')
        : require('~/assets/images/party-popper.png')
    }
  },
  watch: {
    showResult(val) {
      if (val) {
        this.changeDialogWidth('512px')
      } else {
        this.changeDialogWidth('724px')
      }
    }
  },
  created() {
    this.setDocumentsStates()
  },
  methods: {
    handleStop() {
      this.isStopped = true
      this.closeModal(false)
    },
    setDocumentsStates() {
      for (const doc of this.documents) {
        const documentState = {
          loading: false,
          error: null,
          passed: false,
          status: this.statuses.created
        }
        this.$set(this.documentsStates, doc.id, documentState)
      }
    },
    async handleRequest() {
      this.showStop = true
      for (const document of this.documents) {
        if (this.isStopped) {
          return
        }
        try {
          this.documentsStates[document.id].loading = true
          if (this.additionalCheckValue) {
            const isValidAdditionalCheckValue = this._.get(document, this.additionalCheckValue)
            if (!isValidAdditionalCheckValue) {
              this.documentsStates[document.id].error = this.genericErrorMessage
              this.documentsStates[document.id].status = this.statuses.error
              continue
            }
          }
          if (!this._.isFunction(this.request)) {
            this.$handlers.error('No request to call', this)
            return
          }
          await this.request({ id: document.id })
          this.documentsStates[document.id].status = this.statuses.success
          // this.$notification.success(msg) // todo
        } catch (e) {
          this.documentsStates[document.id].error =
            this._.get(e, 'response.data.detail') || this._.get(e, 'response.data.message')
          this.documentsStates[document.id].status = this.statuses.error
        } finally {
          this.documentsStates[document.id].passed = true
          this.documentsStates[document.id].loading = false
        }
      }
      this.showStop = false
      this.showResult = true
    }
  }
}
</script>

<style scoped lang="scss"></style>
